var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationIcon02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0.900391C16.5651 0.900391 21.0995 5.35921 21.0996 10.8887C21.0996 13.7109 19.5153 16.7342 17.6055 18.9951C16.6359 20.1428 15.5391 21.1478 14.4336 21.874C13.3506 22.5853 12.1514 23.0996 11 23.0996C9.8486 23.0996 8.64944 22.5853 7.56641 21.874C6.46085 21.1478 5.36407 20.1428 4.39453 18.9951C2.48466 16.7342 0.900391 13.7109 0.900391 10.8887C0.900515 5.35921 5.43493 0.900391 11 0.900391ZM11 3.09961C6.62411 3.09961 3.09973 6.59992 3.09961 10.8887C3.09961 12.9755 4.32804 15.5079 6.07422 17.5752C6.93273 18.5915 7.87517 19.4451 8.77344 20.0352C9.69419 20.64 10.4641 20.9004 11 20.9004C11.5359 20.9004 12.3058 20.64 13.2266 20.0352C14.1248 19.4451 15.0673 18.5915 15.9258 17.5752C17.672 15.5079 18.9004 12.9755 18.9004 10.8887C18.9003 6.59992 15.3759 3.09961 11 3.09961ZM11 6.90039C13.2644 6.90039 15.0996 8.73563 15.0996 11C15.0996 13.2644 13.2644 15.0996 11 15.0996C8.73563 15.0996 6.90039 13.2644 6.90039 11C6.90039 8.73563 8.73563 6.90039 11 6.90039ZM11 9.09961C9.95066 9.09961 9.09961 9.95066 9.09961 11C9.09961 12.0493 9.95066 12.9004 11 12.9004C12.0493 12.9004 12.9004 12.0493 12.9004 11C12.9004 9.95066 12.0493 9.09961 11 9.09961Z",
    fill: "url(#paint0_linear_1552_5729)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1552_5729",
    x1: -0.465398,
    y1: 19.3879,
    x2: 22.6352,
    y2: 3.02863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C32FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#00A4AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D4FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon02);
export default __webpack_public_path__ + "static/media/location-icon02.2e5a75113b91685e9f963450b7bb930e.svg";
export { ForwardRef as ReactComponent };